export const ValidationType = {
  Success: 0,
  InvalidToken: 1,
  InvalidOperation: 2,
  PlayerLimitExceeded: 3,
  PartnerNotFound: 4,
  MoneyTransactionError: 5,
};